import React from 'react';
import PropTypes from 'prop-types';

import VisualizerProductListItem from '../VisualizerProductListItem/VisualizerProductListItem';

import { StyledGrid } from './VisualizerProductListStyles';

var VisualizerProductList = function VisualizerProductList(props) {
  return React.createElement(
    StyledGrid,
    null,
    props.products.map(function (product) {
      var filteredItems = product.variantId && (props.selectedFilter === '' || product.selectedOptions[0].value === props.selectedFilter.replace('twin xl', 'twin-xl'));
      if (filteredItems) {
        return React.createElement(VisualizerProductListItem, {
          key: product.variantId,
          categoryTitle: props.categoryTitle,
          maxItems: props.maxItems,
          product: product,
          selectedProducts: props.selectedProducts,
          handleProductSelection: props.handleProductSelection,
          isStaging: props.isStaging
        });
      } else {
        return null;
      }
    })
  );
};

VisualizerProductList.propTypes = {
  active: PropTypes.bool.isRequired,
  selectedFilter: PropTypes.string,
  products: PropTypes.array,
  categoryTitle: PropTypes.string,
  maxItems: PropTypes.number,
  selectedProducts: PropTypes.array,
  handleProductSelection: PropTypes.func,
  isStaging: PropTypes.bool.isRequired
};

export default VisualizerProductList;